import React from 'react'
import ReactModal from "react-modal";
import NflMapContainer from "./NflMapContainer";
import UnitedStatesMapContainer from "./UnitedStatesMapContainer";
import EuropeMapContainer from "./EuropeMapContainer";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import MlbMapContainer from "./MlbMapContainer";
import NationalParksMapContainerFour from "./NationalParkMapContainerFour";
import WorldMapContainer from "./WorldMapContainer";

function BucketListModal({selectedBucketList, onClose}) {

    const displaySelectedBucketList = () => {
        if (selectedBucketList === "NFL") {
            return <NflMapContainer/>
        } else if (selectedBucketList === "United States") {
            return <UnitedStatesMapContainer/>
        } else if (selectedBucketList === "Europe") {
            return <EuropeMapContainer/>
        } else if (selectedBucketList === 'MLB') {
            return <MlbMapContainer/>
        } else if (selectedBucketList === "National Park") {
            return <NationalParksMapContainerFour/>
        } else if (selectedBucketList === 'World') {
            return <WorldMapContainer />
        }
        return null
    }

    return (
        <ReactModal isOpen={!!selectedBucketList} className="view-bucket-list-modal">
            <div className="exit-bucket-list-modal">
                <CancelPresentationIcon sx={{fontSize: 50}} onClick={() => {
                    onClose()
                }}/>
            </div>
            {displaySelectedBucketList()}
        </ReactModal>
    )
}

export default BucketListModal;